import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { BaseStructuredFormFields } from '@/pages/instruments/new-instrument/fields/base-structured.fields'
import { OptionalStructuredFields } from '@/pages/instruments/new-instrument/fields/structured.optional.fields'
import { BarrierTypeFormField } from '@/pages/instruments/new-instrument/form-fields/BarrierTypeFormField'
import { ContractTypeField } from '@/pages/instruments/new-instrument/form-fields/ContractTypeFormField'
import { KnockDownInputLevelFormField } from '@/pages/instruments/new-instrument/form-fields/KnockDownInputLevelFormField'
import { ParticipationRateFormField } from '@/pages/instruments/new-instrument/form-fields/ParticipationRateFormField'

export interface VanillaStructuredFormFieldsProps {}

export const VanillaStructuredFormFields: React.FC<VanillaStructuredFormFieldsProps> = ({}) => {
  return (
    <div className="grid gap-6 @2xl:grid-cols-2 @2xl:gap-10">
      <BaseStructuredFormFields />
      <div className={'@container flex flex-col gap-6'}>
        <FormFieldRow>
          <ContractTypeField />
          <ParticipationRateFormField />
          <BarrierTypeFormField />
          <KnockDownInputLevelFormField />
        </FormFieldRow>
        <OptionalStructuredFields />
      </div>
    </div>
  )
}
